"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KpiStats = void 0;
const react_1 = require("react");
const React = require("react");
require("./kpi-stats.less");
class KpiStats extends react_1.Component {
    render() {
        const { color = "white", largeMargin = false, stats = {} } = this.props;
        const labelColor = color === "white" ? " kpi-stats__white-label" : " kpi-stats__grey-label";
        const leftMargin = largeMargin
            ? " kpi-stats__large-margin"
            : " kpi-stats__normal-margin";
        const valueSize = color === "white"
            ? " kpi-stats__small"
            : color === "gradient"
                ? " kpi-stats__medium"
                : " kpi-stats__large";
        const greenValue = color === "green" ? " kpi-stats__green-value" : "";
        return (React.createElement("div", { className: `kpi-stats${leftMargin}` }, Object.keys(stats).map((label, index) => (React.createElement("div", { className: "kpi-stats__column", key: index },
            React.createElement("div", { className: `kpi-stats__label${labelColor}` }, label),
            React.createElement("div", { className: `kpi-stats__value${valueSize}${greenValue}${this.getGradientClassName(color, index)}` }, stats[label].toLocaleString()))))));
    }
    getGradientClassName(color, index) {
        if (color === "gradient") {
            if (index === 0) {
                return " kpi-stats__blue-value";
            }
            else if (index === 1) {
                return " kpi-stats__aqua-value";
            }
            else {
                return " kpi-stats__green-value";
            }
        }
        return "";
    }
}
exports.KpiStats = KpiStats;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/kpi-header/kpi-stats/kpi-stats.tsx
// module id = 3643
// module chunks = 0